import {
  type IEdge,
  type ILabel,
  type IRenderContext,
  LabelStyleBase,
  Rect,
  Size,
  Visual,
} from '@ardoq/yfiles';
import type { GraphEdgeBase } from '@ardoq/graph';
import {
  measureNodeLabel,
  MODERNIZED_BLOCK_DIAGRAM_LINE_HEIGHT as LINE_HEIGHT,
} from '@ardoq/graph-labeling';
import { CanvasLabelVisual } from './CanvasLabelVisual';
import { MODERNIZED_BLOCK_DIAGRAM_EDGE_LABEL_MAX_WIDTH as MAX_WIDTH } from 'yfilesExtensions/styles/consts';
import { wrapString } from 'tabview/blocks/misc/string';
import { MODERNIZED_BLOCK_DIAGRAM_LABEL_MAX_LINES as MAX_LINES } from 'yfilesExtensions/styles/modernized/consts';
import { getEdgeLabels } from '../shared/layoutUtils';

const PADDING = 2;

class CanvasLabelStyle extends LabelStyleBase {
  static Instance = new CanvasLabelStyle();
  private constructor() {
    super();
  }
  protected override createVisual(
    context: IRenderContext,
    label: ILabel
  ): Visual | null {
    const {
      owner,
      layout: { bounds },
    } = label;

    const edgeLabels = getEdgeLabels(context);
    if (!edgeLabels) return null;

    const { tag } = owner as IEdge;
    const { id, isTransparentized } = tag as GraphEdgeBase;
    const wrappedLabel = edgeLabels.get(id);
    if (!wrappedLabel) {
      return null;
    }

    const { x, y, width, height } = bounds;
    const textBounds = new Rect(
      x + PADDING,
      y + PADDING,
      width - 2 * PADDING,
      height - 2 * PADDING
    );

    return new CanvasLabelVisual(
      textBounds,
      bounds,
      wrappedLabel,
      isTransparentized ? 0.32 : 1
    );
  }

  protected override getPreferredSize(label: ILabel): Size {
    const { text } = label;
    if (!text) {
      return Size.EMPTY;
    }
    const wrappedLabel = wrapString(
      text,
      MAX_WIDTH,
      measureNodeLabel,
      MAX_LINES
    );
    if (!wrappedLabel.length) {
      return Size.EMPTY;
    }
    const width = Math.max(...wrappedLabel.map(measureNodeLabel));
    const height = wrappedLabel.length * LINE_HEIGHT;
    return new Size(width + 2 * PADDING, height + 2 * PADDING);
  }
}
export { CanvasLabelStyle };
